document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname === "/cart") {
    document.querySelectorAll("header-mini-cart-dropdown-modal .mini-cart-bss-te").forEach(function(el) {
      el.remove();
    });
  }

  setTimeout(() => {
    // KC Custom VAT + SUBMIT FORM
    let checkVAT = true;
    const vatElement = document.querySelector(".vat-validation");
    if(vatElement) {
      vatElement.addEventListener("change", e => {
        const loadingHTML = `<span class="bss-message">
        <div bis_skin_checked="1" style="display: inline-block;"><div class="bss-loader" style="display: block;" bis_skin_checked="1"></div></div> 
        <span style="color: rgb(0, 128, 0);">VAT is being checked, please wait a moment.</span></span>`;
        const message = document.querySelector('#vat-validation+.bss-message');
        const value = document.querySelector(".vat-validation").value;
        if(value.length > 0) {
          setTimeout(() => {
            message.innerHTML = loadingHTML;
          }, 500)
        }
        checkVAT = true;
      }, 1)
    }

    const formRF = document.querySelector("#bss-b2b-register-form");
    if(formRF) {
      formRF.addEventListener("submit", e => {
          if(checkVAT) {
              const targetNode = document.querySelector('#vat-validation+.bss-message');
              if (targetNode) {
                  const config = { attributes: true };
                  const callback = function (mutationsList) {
                      const buttonSubmit = document.querySelector(`.bss-b2b-rf-submit-button [type="submit"]`);
                      const messageVAT = document.querySelector(`#vat-validation+.bss-message`);
                      if(messageVAT.innerText === 'VALID VAT NUMBER') {
                        setTimeout(() => {
                          buttonSubmit.click();
                        }, 1000)
                      }
                  };
                  const observer = new MutationObserver(callback);
                  observer.observe(targetNode, config);
              }
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation()
              checkVAT = false;
              return;
          }
      }, 1)
    }

    // CUSTOM END

    const vatInput = document.querySelector("#vat-validation");
    const submitBtn = document.querySelector('.bss-b2b-rf-submit-button input[type="submit"]');
    let timer;

    const disableBtn = () => {
      // submitBtn.disabled = true;
      // submitBtn.style.opacity = "0.5";
      // submitBtn.style.cursor = "not-allowed";
    };

    const enableBtn = () => {
      // submitBtn.disabled = false;
      // submitBtn.style.opacity = "1";
      // submitBtn.style.cursor = "pointer";
    };

    const startCountdown = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        enableBtn();
      }, 2000);
    };

    if (vatInput && submitBtn) {
      // Khi gõ hoặc chọn suggest → disable ngay lập tức
      vatInput.addEventListener("input", () => {
        if (vatInput.value.trim() !== "") {
          disableBtn();
        } else {
          enableBtn();
        }
      });

      // Khi người dùng rời khỏi input (blur) hoặc chọn suggest (change) → bắt đầu đếm 3 s
      vatInput.addEventListener("blur", () => {
        if (vatInput.value.trim() !== "") startCountdown();
      });

      vatInput.addEventListener("change", () => {
        if (vatInput.value.trim() !== "") startCountdown();
      });

      // Dán trực tiếp → disable ngay và sẽ chỉ bật sau khi blur
      vatInput.addEventListener("paste", () => {
        if (vatInput.value.trim() !== "") disableBtn();
      });
    }
  }, 2000);

  setTimeout(() => {
    const tags = BSS_B2B?.shopData?.customer?.tags || [];
    const isB2B = tags.includes("b2b") || tags.includes("b2b - 0% VAT");

    if (!isB2B) return;

    //cl
    document.querySelectorAll(".card-product").forEach(function(container) {
    if (container.querySelector(".price-sale .price-item-sale > span:has(+span)")) {
      const regulars = document.querySelectorAll("s.price-item.price-item-regular");
      regulars.forEach(regular => {
        regular.style.display = "none";
      });
    }

    // pdp
    document.querySelectorAll(".product-info").forEach(function(container) {
    if (container.querySelector(".price-item-sale > span:has(+span)")) {
      const regulars = document.querySelectorAll("s.price-item.price-item-regular");
      regulars.forEach(regular => {
        regular.style.display = "none";
      });
    }
  });
    });
  }, 1000);
});

const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;


  let counter = 0;
  const interval = setInterval(() => {
    const taxExWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper.bss-config-header");

    if (taxExWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);


function handleTEBox() {
  if(!BSS_B2B?.te?.teTranslations) return;
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.classList?.contains('header-mini-cart-footer')) {
          BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, 300);
}

(() => {
    const checkoutSelector = "[name='checkout'], .bss-checkout";
    document.addEventListener("DOMContentLoaded", e => {
        const checkoutElements = document.querySelectorAll(checkoutSelector);
        checkoutElements.forEach(checkout => checkout.addEventListener("click", e => {
            setCheckoutBtnLoading(true, checkoutElements);
        }, true));

        const targetNode = document.querySelector('div.bss-b2b-tax-ex-wrapper');
        if (targetNode) {
            const config = { attributes: true };
            const callback = function (mutationsList) {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'attributes') {
                        const newValue = targetNode.getAttribute(mutation.attributeName);
                        if (newValue.startsWith("ERR_") || newValue.startsWith("VAT_SUCCESS") || newValue.startsWith("VAT_VALIDATECOUNTRY")) {
                            setCheckoutBtnLoading(false, checkoutElements);
                        }
                    }
                }
            };
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        } else {
            setCheckoutBtnLoading(false, checkoutElements);
        }
    });
})();

function setCheckoutBtnLoading(status, checkoutElements, checkoutSelector = '', productForm) {
    const loaderAttr = 'bss-b2b-checkout-loader';
    const defaultAttr = 'bss-b2b-default-checkout';

    if (status) {
        const bssLoader = `<div style="display: flex;"><div class="bss-loader" style="display: block;"></div></div>`;
        checkoutElements.forEach((checkoutElem) => {
            if (checkoutElem instanceof HTMLElement) {
                const checkoutElemLoader = checkoutElem.cloneNode(true);
                if (checkoutElemLoader instanceof HTMLButtonElement) {
                    checkoutElemLoader.disabled = true;
                } else {
                    checkoutElemLoader.style.cursor = 'none';
                }
                checkoutElemLoader.setAttribute(loaderAttr, 'true');
                checkoutElemLoader.innerHTML = bssLoader;
                checkoutElem.style.setProperty('display', 'none', 'important');
                checkoutElem.after(checkoutElemLoader);
                checkoutElem.setAttribute(defaultAttr, 'true');
            }
        });
    } else {
        document.querySelectorAll(`[${loaderAttr}]`).forEach(el => el.remove());

        let isShow = true;
        if (productForm) {
            const defaultBIN = productForm.querySelector('[bss-b2b-default-buy-now]');
            if (defaultBIN && window.getComputedStyle(defaultBIN).display === 'block') {
                isShow = false;
            }
        }

        if (isShow) {
            document.querySelectorAll(`[${defaultAttr}]${checkoutSelector}`)
                .forEach((item) => {
                    item.style.display = 'block';
                });
        }
    }
}